import { type AsyncStateObject, type Action, type OrgAndRoleHierarchy } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, HIERARCHY_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<OrgAndRoleHierarchy> = {
  data: { levelName: '', levelId: '', levelIndex: -1, subLevels: [] },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const roleHierarchyReducer = (
  state = INITIAL_STATE,
  action: Action<OrgAndRoleHierarchy>
): AsyncStateObject<OrgAndRoleHierarchy> => {
  switch (action.type) {
    case HIERARCHY_ACTIONS.GET_ROLE_HIERARCHY + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case HIERARCHY_ACTIONS.GET_ROLE_HIERARCHY + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case HIERARCHY_ACTIONS.GET_ROLE_HIERARCHY + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: { levelName: '', levelId: '', levelIndex: -1, subLevels: [] },
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case HIERARCHY_ACTIONS.GET_ROLE_HIERARCHY + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default roleHierarchyReducer
